export const partitionTopAndRest = <T>(
  options: T[],
  topOptionsCount = 5
): [T[], T[]] => {
  const top = options.slice(0, topOptionsCount);
  const rest = options.slice(topOptionsCount);

  return [top, rest];
};
